<!--
 * @Author: codesides
 * @Descripttion: 
 * @Date: 2022-05-06 17:56:52
 * @LastEditors: qianyl
 * @LastEditTime: 2024-11-22 16:16:09
 * @FilePath: \lesson-web-cms\src\App.vue
-->
<template>
  <a-config-provider :locale="zhCN">
    <router-view v-if="store.state.loaded" />
    <loadingPage v-else />
  </a-config-provider>
</template>
<script setup lang="ts">
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import { useStore } from 'vuex'
import { getCommon } from '@/api/common'
import loadingPage from '@/components/loadingPage.vue'
import Cookies from 'js-cookie'
// import { useSelectUser } from "@/hooks/useSelectUser";

// useSelectUser()
dayjs.locale('zh-cn')
const store = useStore()

store.dispatch('GET_BASE')

getCommon().then((res) => {
  Cookies.set('X-Access-Token', res.data.loginToken || '')
  // if(process.env.NODE_ENV === 'development') {
  //   Cookies.set("X-Access-Token",
  //     "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1bml0VHlwZSI6IjEiLCJ1bml0SWQiOiIxMDI3MjY1OTAwNDEzMTk0MjQyIiwidXNlclR5cGUiOiI2IiwiZXhwIjoxNzM3MjI1OTMyLCJ1c2VySWQiOiIxMjk3MTgxMTUwMzkxODMzNjAiLCJ0b2tlbk1hcmsiOiJkYTk5N2U0M2E1MGQ3NWUyZTc3ZmI3NmRmN2UyZmZlYSIsInVzZXJuYW1lIjoianhzbmNzcXNocV9hZG1pbiJ9.ORQPF8COdAyRkhczshsByrCFUyGAFj4iF6CNx2HboeA"
  //   );
  // }
  const { data } = res
  let emptyFavicon =
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
  let fav: any = document.querySelector('link[rel="icon"]')
  if (!fav) {
    fav = document.createElement('link')
    fav.rel = 'icon'
    document.head.appendChild(fav)
  }
  fav.href = data?.title || emptyFavicon
})
</script>
